import { render, staticRenderFns } from "./policiesRegulations.vue?vue&type=template&id=d895ace6&scoped=true"
import script from "./policiesRegulations.vue?vue&type=script&lang=js"
export * from "./policiesRegulations.vue?vue&type=script&lang=js"
import style0 from "./policiesRegulations.vue?vue&type=style&index=0&id=d895ace6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d895ace6",
  null
  
)

export default component.exports